import React, { useEffect, useRef } from 'react';

interface AdLeaderboardBottomProps {
  className?: string;
}

const AdLeaderboardBottom: React.FC<AdLeaderboardBottomProps> = ({ className }) => {
  const adContainerRef = useRef<HTMLDivElement>(null);
  const isScriptInjected = useRef(false);

  useEffect(() => {
    if (isScriptInjected.current || !adContainerRef.current) return;
    
    // Create and inject the provider script
    const providerScript = document.createElement('script');
    providerScript.async = true;
    providerScript.type = 'application/javascript';
    providerScript.src = 'https://a.magsrv.com/ad-provider.js';
    
    // Create the ins element
    const insElement = document.createElement('ins');
    insElement.className = 'eas6a97888e2';
    insElement.setAttribute('data-zoneid', '5619446');
    insElement.setAttribute('data-keywords', 'tattoo,design,art,ink,tattooart,ai,artificialintelligence,nail,nailart');
    insElement.setAttribute('data-sub', '123450000');
    
    // Create the initialization script
    const initScript = document.createElement('script');
    initScript.textContent = '(AdProvider = window.AdProvider || []).push({"serve": {}});';
    
    // Append all elements to the container
    adContainerRef.current.appendChild(providerScript);
    adContainerRef.current.appendChild(insElement);
    adContainerRef.current.appendChild(initScript);
    
    isScriptInjected.current = true;
    
    // Cleanup function
    return () => {
      if (adContainerRef.current) {
        adContainerRef.current.innerHTML = '';
      }
      isScriptInjected.current = false;
    };
  }, []);

  return (
    <div 
      ref={adContainerRef} 
      className={`ad-leaderboard-bottom w-full overflow-hidden ${className || ''}`}
      style={{ height: '90px', maxWidth: '728px', margin: '0 auto' }}
    />
  );
};

export default AdLeaderboardBottom;